export const EncryptionKeyCloudVendor = {
    GCP: 'gcp',
} as const;

export const EncryptionKeySecretManagerReferenceStorageVersion = {
    V2: 2,
} as const;

export const EncryptionKeySecretManagerVersionNumber = {
    V1: 1,
} as const;

export type GcpEncryptionKeySecretManagerReference = {
    secret_manager_reference_version: typeof EncryptionKeySecretManagerReferenceStorageVersion.V2;
    cloud_vendor: typeof EncryptionKeyCloudVendor.GCP;
    family: string;
    sequence_number: number;
    version_number: typeof EncryptionKeySecretManagerVersionNumber.V1;
};

export type EncryptionKeySecretManagerReference = GcpEncryptionKeySecretManagerReference;
